module.exports = __webpack_public_path__ + "static/media/team-swimmy-raidouane.5366b45b.png";